import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=1ba3b68a&scoped=true&"
import script from "./terms.vue?vue&type=script&lang=ts&"
export * from "./terms.vue?vue&type=script&lang=ts&"
import style0 from "./terms.vue?vue&type=style&index=0&id=1ba3b68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3b68a",
  null
  
)

export default component.exports